export default __webpack_public_path__ + "static/media/del-monte.bd97edfd.png";